import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types';
import { Container } from 'react-grid-system'
import Header from '../Header/index'
// import Footer from '../Footer/index'

const Body = styled(Container)`
  padding-bottom: 3rem;
  padding-top: 3rem;
`

const Layout = (props) => {
  return (
    <div>
      <Header
        title={props.title}
        backIcon={props.backIcon}
        closeIcon={props.closeIcon}
        onClick={props.onClick}
      />
      <Body style={props.style}>
        {props.children}
      </Body>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  backIcon: PropTypes.bool,
  closeIcon: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.any
};

Layout.defaultProps = {
  backIcon: false,
  closeIcon: false
};

export default Layout
